<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <router-link to="/logout">
                  <span class="sidebar-mini">UIT</span>
                  <span class="sidebar-normal">Uitloggen</span>
                </router-link>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isClosed: true,
      avatar:
        this.$apiBaseUrl +
        "../user/" +
        localStorage.getItem("user_id") +
        "/avatar" // process.env.VUE_APP_AVATAR
    };
  },
  computed: {
    title() {
      return (
        localStorage.getItem("user_firstName") +
        " " +
        localStorage.getItem("user_lastNamePrefix") +
        " " +
        localStorage.getItem("user_lastName")
      );
    }
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
